export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-feedback/es/index.js
// module id = 657
// module chunks = 0 1